import { FC } from 'react';
import { useFormContext } from '../../../../../../contexts/FormContext';
import { CardButtons } from '../CardButtons';

import styles from './CallToActionCard.module.css';

type CallToActionCardProps = {
  responseIndex: number;
  text: string;
  id?: string;
};

export const CallToActionCard: FC<CallToActionCardProps> = ({
  text,
  responseIndex,
  id,
}) => {
  const { subheaderInput } = useFormContext();

  if (!subheaderInput) return null;

  return (
    <div className={styles['container']}>
      <p>{text}</p>
      <CardButtons responseIndex={responseIndex} id={id ?? ''} />
    </div>
  );
};
